module.exports = __webpack_public_path__ + "static/media/team_03.e2862a26.jpg";